// extracted by mini-css-extract-plugin
export default {"videoList":"index_videoList_XGIlc","list":"index_list_9tgL9"};